import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteLine = ({ lineId }: { lineId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Lines/DeleteLine/${lineId}`);
};

type QueryFnType = typeof deleteLine;

type UseDeleteLineOptions = {
  lineId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteLine = ({ config }: UseDeleteLineOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή της Γραμμής.`, 500);
      console.error("Couldnt delete Line", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllLines"]);
      addNotification(`Η Γραμμή Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteLine,
  });
};
